const Web3 = require("web3");
var web3;

if (window.ethereum) {
  web3 = new Web3(window.ethereum);
} else if (window.web3) {
  const provider = new Web3.providers.HttpProvider(
    "https://rinkeby.infura.io/v3/bcb2eb9ea56148be9bda068196cd50c7"
  );
  web3 = new Web3(provider);
} else {
  const provider = new Web3.providers.HttpProvider(
    "https://rinkeby.infura.io/v3/bcb2eb9ea56148be9bda068196cd50c7"
  );
  web3 = new Web3(provider);
}

export default web3;
